import styled from 'styled-components';
export default styled.h3`
  color: #000000;
  font-family: 'Roboto', sans-serif;
  font-size: 17px;
  line-height: 16px;
`